import Pikaday from 'pikaday';
import Choices from 'choices.js';

export default function datepicker() {
    const dateInput = document.querySelector('#date');
//    const test2Select = document.getElementById('test2'); 

//document.querySelectorAll('.choices__list')[1].querySelectorAll('.choices__item').forEach(s=>console.log(s));
//let s2s = document.querySelector('#choices--time-item-choice-8');
//s2s.classList;
//s2s.classList.remove('choices__i…oices__item--selectable');

var customSelect = new Choices(document.querySelector('.js-custom-select'), {
	searchEnabled: false,
	itemSelectText: '',
	shouldSort: false,
	placeholder: true,
	placeholderValue: 'Выбрать время',
	classNames: {
        	containerOuter: 'choices',
	        containerInner: 'choices__inner',
	        input: 'choices__input',
	        inputCloned: 'choices__input--cloned',
	        list: 'choices__list',
	        listItems: 'choices__list--multiple',
	        listSingle: 'choices__list--single',
	        listDropdown: 'choices__list--dropdown',
	        item: 'choices__item',
	        itemSelectable: 'choices__item--selectable',
	        itemDisabled: 'choices__item--disabled',
	        itemChoice: 'choices__item--choice',
	        group: 'choices__group',
	        groupHeading : 'choices__heading',
	        button: 'choices__button',
	        activeState: 'is-active',
	        focusState: 'is-focused',
	        openState: 'is-open',
	        disabledState: 'is-disabled',
	        highlightedState: 'is-highlighted',
	        hiddenState: 'is-hidden',
	        flippedState: 'is-flipped',
	        loadingState: 'is-loading',
	    },
 });


const dfdd = customSelect.config.choices;
customSelect.clearChoices();
function getMethods(obj) {
  const methods = [];
  do {
    for (const prop of Object.getOwnPropertyNames(obj)) {
      if (obj[prop] instanceof Function) methods.push(prop);
    }
    obj = Object.getPrototypeOf(obj);
  } while (obj !== null)

  return methods;
}

function containsString(date) {
  let value = date.toLocaleDateString('ru', { day: '2-digit', month: '2-digit', year: '2-digit'});
  for (let i = 0; i < holidays.length; i++) if (holidays[i] === value) return true;
  return false;
}

const picker = new Pikaday({
	firstDay: 1,
	field: dateInput,
        format: 'DD.MM.YYYY',
        minDate: new Date(),
        container: dateInput.parentElement,
        showDaysInNextAndPreviousMonths: true,
        i18n: {
            previousMonth : 'Предыдущий месяц',
            nextMonth     : 'Следующий месяц',
            months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            weekdays      : ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
            weekdaysShort : ['вс','пн','вт','ср','чт','пт','сб']
        },
	onSelect(date){
		if ([0].indexOf(date.getDay()) >= 0 )
		{
		  customSelect.disable();
		  return;
		}
		else if (containsString(date))
		{
		  customSelect.disable();
		  return;
		}
		else if ([6].indexOf(date.getDay()) >= 0)
		{
		   customSelect.enable();
		   customSelect.clearChoices();
		   dfdd.forEach(function(el){ if(el.value!='17:00') customSelect.setValue(el)});
		   customSelect.removeActiveItems();
		  return;
		}
		else
		{
           customSelect.enable();
           customSelect.clearChoices();
           dfdd.forEach(function(el){customSelect.setValue(el)});
		   customSelect.removeActiveItems();
		  return;
		}
	},
	disableDayFn: (date) =>{if ([0].indexOf(date.getDay()) >= 0 || containsString(date) ){return { enabled: false, classes: "is-disabled" };}}
    });
}